import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import PageHead from "@/pages/Head";
import FooterOne from "@/components/Footer/Footer-One";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import BreadCrumb from "@/components/Common/BreadCrumb";
import Gallery from "@/components/Gallery/Gallery";
import Image from "next/image";
import restaurantImg from "../../public/images/restaurant/restaurant_flyer.jpg";
import restaurantGalleryData from "../../data/elements/restaurantGallery.json";

const Restaurant = () => {
  return (
    <>
      <PageHead title="Restaurante - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <BreadCrumb 
            title="Restaurante - Cafetería" 
            text="Restaurante" />
          <div className="bg-color-white rbt-section-gap2">
            <div className="container">
              <div className="row g-5 align-items-center">
                <div className="col-lg-6">
                  <Image
                    className="w-100 rbt-radius"
                    src={restaurantImg}
                    width={407}
                    height={638}
                    property="true"
                    alt="Restaurant info flyer"
                  />
                </div>
                <div className="container col-lg-6 rbt-section-gapTopHalf">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <div className="section-title text-start">
                      <h4 className="title"> Cafetería el buen sabor </h4>
                      <p className="description mt--20 mb--20">
                        En el Colegio Menfis sabemos que una buena alimentación es la base para aprender, crecer y ser feliz. Por eso, nuestro Restaurante Escolar “El Buen Sabor” es mucho más que un lugar para comer: es un espacio donde cada plato se prepara con amor, dedicación y cuidado, pensando siempre en el bienestar de nuestros estudiantes.
                      </p>
                      <p className="description mb--20">
                        Gracias al esfuerzo y compromiso de doña Bibiana, junto a María José y Lina, cada día ofrecemos comidas caseras, saludables y balanceadas, con porciones adecuadas a la edad de cada niño o adolescente. Nos enfocamos en reducir el exceso de azúcares y alimentos procesados, promoviendo hábitos saludables que benefician no solo el cuerpo, sino también la mente y el corazón. 
                      </p>
                      <p className="description mb--20">
                        Nuestros refrigerios de la mañana y la tarde están pensados para mantener la energía y la concentración durante toda la jornada. Las cocineras, con su toque casero y cariño, son parte fundamental de la experiencia Menfis: su trabajo refleja el compromiso de brindar calidad, bienestar y felicidad a toda nuestra comunidad educativa.
                      </p>
                      <p className="description mb--20">
                        Barriga llena, corazón contento… y mente concentrada.
                      </p>
                      <div className="description mb--20">
                        <p className="description mb--0"><b>Precios 2025:</b></p>
                        <ul className="description mb--0">
                            <li>Niños: $7.500 COP</li>
                            <li>Adultos: $9.500 COP</li>
                        </ul> 
                        <p>Pago semanal o mensual a través de transferencia.</p>
                      </div>
                      <p className="description mb--20">
                        Porque en Menfis, cuidamos el cuerpo y alimentamos el alma.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Gallery 
            galleryData={restaurantGalleryData}
          />
          <Separator />
          <BackToTop />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default Restaurant;
